import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, delay, filter, retryWhen, switchMap, take, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ConfigsLoaderService } from './config-loader.service';
import { MVLocalStorageService } from './mv-local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class TenantSelectorService {
  private apiEndPoint: string;


  get selectedTenant(): Observable<{ id: string, description: string }> {
    return this._selectedTenant.asObservable();
  }

  // tslint:disable-next-line: variable-name
  private _selectedTenant = new BehaviorSubject<{ id: string, description: string }>(undefined);


  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private config: ConfigsLoaderService
  ) {
    this.apiEndPoint = this.config.apiUrl;

    auth.currentUser$
      .pipe(
        filter(user => !!user)
      )
      .subscribe(user => {
        // this._tenants.next(user.tenants);
        this.getLocalStorageTenant(user);
      });
  }


  selectTenant(tenant: { id: string, description: string }): void {
      this._selectedTenant.next(tenant);
  }

  private getLocalStorageTenant(user?) {
    // const tenant = JSON.parse(MVLocalStorageService.getItem('selected_tenant'));
    // if (tenant && this._tenants.value.find(c => c.id === tenant.id)) {
    //   this._selectedTenant.next(this._tenants.value?.find(c => c.id === tenant.id));
    // } else if (user.defaultTenantId && this._tenants?.value.find(c => c.id === user.defaultTenantId)) {
    //   this._selectedTenant.next(this._tenants.value?.find(c => c.id === user.defaultTenantId));
    //   this.setLocalStorageTenant(this.currentSelectedTenant());
    // } else {
    //   this._selectedTenant.next(this._tenants.value[0]);
    //   this.setLocalStorageTenant(this.currentSelectedTenant());
    // }
  }

  // private setLocalStorageTenant(tenant) {
  //   MVLocalStorageService.setItem('selected_tenant', JSON.stringify(tenant));
  //   this.auth.changeDefaultTenant(tenant.id);
  // }

  currentSelectedTenant(): { id: string; description: string } {
    return this._selectedTenant.getValue();
  }
}
